var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"x-player"},[_c('video',{staticClass:"video-js",attrs:{"id":_vm.id,"width":"100%","height":"100%","poster":_vm.poster,"webkit-playsinline":"","playsinline":"","x5-playsinline":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }